import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Historical from './components/Historical'
import Occupancy from './components/Occupancy';
import DeviceManagement from './components/Devices';
import Login3 from './components/Login3';

const isAuthenticated = () => {
  return localStorage.getItem("access_token") !== null;
};

// Protected Route wrapper component
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    console.error("Unauthorized access attempt to a protected route.");
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/login" element={<Login3 />} />
          <Route path="/" element={<Login3 />} />
          
          <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
          <Route path="/desks" element={<ProtectedRoute><Occupancy /></ProtectedRoute>} />
          <Route path="/historical-data" element={<ProtectedRoute><Historical /></ProtectedRoute>} />
          <Route path="/device-management" element={<ProtectedRoute><DeviceManagement /></ProtectedRoute>} />
          
        </Routes>
      </div>
    </Router>
  );
}

export default App;